module.exports = __webpack_public_path__ + "static/media/review-answers-image.dfc1327e.png";